import { deepClone } from '@/modules/core/helper';
import { DataSourceType, ID_STRING } from '@/modules/core/app/constants/datasource.constants';
import { DASHBOARD_RAW_VALUES } from '@/modules/ta/dashboard/dashboard.constants';

const GLOBAL_FILTER_KEYS = [
  DataSourceType.CLIENT,
  DataSourceType.CLIENT_CATEGORY,
  DataSourceType.CLIENT_GROUP,
  DataSourceType.CLIENT_COUNTRY,
  DataSourceType.CLIENT_STATE,
  DataSourceType.CLIENT_CITY,
  DataSourceType.CLIENT_NAICS_CODE,
  DataSourceType.CLIENT_ADDITIONAL_DETAILS_1,
  DataSourceType.CLIENT_ADDITIONAL_DETAILS_2,
  DataSourceType.CLIENT_ADDITIONAL_DETAILS_3,
  DataSourceType.CLUSTER,
  DataSourceType.SMART_CAMPAIGN,
];

const clearValuesOnFilter = (filter) => {
  if (!filter) {
    return;
  }

  if (Array.isArray(filter)) {
    filter.forEach((item) => {
      /* eslint-disable tap/no-raw-text-js */
      if (item && typeof item === 'object' && Array.isArray(item.values)) {
        item.values = [];
      }
    });
    return;
  }

  if (filter?.values && Array.isArray(filter.values)) {
    filter.values = [];
  }

  Object.keys(filter || {}).forEach((key) => {
    const value = filter[key];
    /* eslint-disable tap/no-raw-text-js */
    if (value && typeof value === 'object' && Array.isArray(value.values)) {
      value.values = [];
    }
  });
};

export const clearDashboardFilterValues = (filters, dashboardId = null) => {
  if (!filters) {
    return null;
  }

  const clearedFilters = deepClone(filters);

  GLOBAL_FILTER_KEYS.forEach((key) => {
    if (clearedFilters?.[key]?.values) {
      clearedFilters[key].values = [];
    }
  });

  if (Array.isArray(clearedFilters?.global_filters)) {
    clearValuesOnFilter(clearedFilters.global_filters);
  }

  if (clearedFilters?.widget_data_warehouse) {
    if (dashboardId) {
      const dashboardFilters = clearedFilters.widget_data_warehouse[dashboardId];
      clearedFilters.widget_data_warehouse = dashboardFilters
        ? { [dashboardId]: dashboardFilters }
        : {};

      if (dashboardFilters?.widget_data_warehouse?.values) {
        dashboardFilters.widget_data_warehouse.values = [];
      }
    } else {
      Object.keys(clearedFilters.widget_data_warehouse).forEach((id) => {
        const dashboardFilters = clearedFilters.widget_data_warehouse[id];
        if (dashboardFilters?.widget_data_warehouse?.values) {
          dashboardFilters.widget_data_warehouse.values = [];
        }
      });
    }
  }

  if (clearedFilters?.widget_sourced) {
    const hasGlobalValues = Array.isArray(clearedFilters.widget_sourced.values);

    if (dashboardId) {
      const dashboardFilters = clearedFilters.widget_sourced[dashboardId];
      const widgetSourced = {};

      if (hasGlobalValues) {
        widgetSourced.values = [];
      }

      if (dashboardFilters) {
        widgetSourced[dashboardId] = dashboardFilters;
        clearValuesOnFilter(widgetSourced[dashboardId]);
      }

      clearedFilters.widget_sourced = widgetSourced;
    } else {
      if (hasGlobalValues) {
        clearedFilters.widget_sourced.values = [];
      }

      Object.keys(clearedFilters.widget_sourced)
        .filter((key) => key !== DASHBOARD_RAW_VALUES.VALUES)
        .forEach((id) => {
          clearValuesOnFilter(clearedFilters.widget_sourced[id]);
        });
    }
  }

  return clearedFilters;
};

export const convertSnakeToCamelCase = (string, removeIdString = false) =>
  string
    .split('_')
    .filter((part) => !removeIdString || part !== ID_STRING)
    .map((part, index) => (index === 0 ? part : `${part[0].toUpperCase()}${part.slice(1)}`))
    .join('');
